import React, { Suspense, useEffect, useState } from 'react';
import {
  Route,
  Routes,
  useNavigate,
  //useLocation
} from 'react-router-dom'
import 'bootstrap/dist/js/bootstrap.min.js'

import Layout from './components/Layout'

import 'bootstrap/dist/css/bootstrap.min.css'
import './scss/button.scss'
import './App.css';

import Loading from './components/Loading';
import SplashScreen from './components/SplashScreen';

import useLiff from './libs/liff/initLiff';
import usePolicy from './libs/checkPolicy';
import Prediction from './pages/Prediction';

const Home = React.lazy(() => import('./pages/Home'))
const TermNCond = React.lazy(() => import('./pages/TermNCondition'))
const PDPA = React.lazy(() => import('./pages/PDPA'))
const Tutorial = React.lazy(() => import('./pages/Tutorial'))
const Landing = React.lazy(() => import('./pages/Landing'))
const Login = React.lazy(() => import('./pages/Login'))
const ConfirmOTP = React.lazy(() => import('./pages/ConfirmOTP'))
const Profile = React.lazy(() => import('./pages/Profile'))
const Treatment = React.lazy(() => import('./pages/Treatment'))
const DeviceConnectionControll = React.lazy(() => import('./pages/DeviceConnectionControll'))
const Results = React.lazy(() => import('./pages/Results'))

function App() {
  const navigate = useNavigate()
  // const location = useLocation()
  let [isLoading, setIsLoading] = useState(true)
  let { initLiff } = useLiff()
  let { policy, setPolicy, getCheckPolicyApi } = usePolicy()

  useEffect(() => {
    // console.log(policy)
    if (policy.status === 200) {
      if (policy.results.isAgreeTermAndCondition === false) {
        navigate('/first')
      } else if (policy.results.isAcceptPdpa === false) {
        navigate('/pdpa')
      } else if (policy.results.isRegister === false) {
        navigate('/tutorial')
      }
    }
    policy.status = 999
    setPolicy(policy)
  }, [policy, navigate, setPolicy])

  useEffect(() => {
    const checkLiffLogin = async () => {
      const liff = await initLiff()
      console.log(`LIFF is Login: ${liff.isLoggedIn()}`)
      if (!liff.isLoggedIn()) {
        console.log('LOGIN AGAIN')
        await liff.login()
      }
      else if (liff.isLoggedIn()) {
        let actk = await liff.getAccessToken()
        localStorage.setItem('actk', actk)
        await getCheckPolicyApi()
      }
      setTimeout(() => {
        setIsLoading(false)
      }, 1500)
    }

    checkLiffLogin()
  }, [initLiff, getCheckPolicyApi])
  
  if (isLoading) return <SplashScreen />
  else
    return (
      <div className="App">
        <div>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={
                <Suspense fallback={<Loading />}>
                  <Home />
                </Suspense>
              } >
              </Route>
              <Route path="first" element={
                <Suspense fallback={<Loading />}>
                  <Landing />
                </Suspense>
              }
              />
              <Route path="term" element={
                <Suspense fallback={<Loading />}>
                  <TermNCond />
                </Suspense>
              }
              />
              <Route path="pdpa" element={
                <Suspense fallback={<Loading />}>
                  <PDPA />
                </Suspense>
              }
              />
              <Route path="tutorial" element={
                <Suspense fallback={<Loading />}>
                  <Tutorial />
                </Suspense>
              }
              />
              <Route path="login" element={
                <Suspense fallback={<Loading />}>
                  <Login />
                </Suspense>
              }
              />
              <Route path="confirm-otp" element={
                <Suspense fallback={<Loading />}>
                  <ConfirmOTP />
                </Suspense>
              }
              />
              <Route path="profile" element={
                <Suspense fallback={<Loading />}>
                  <Profile />
                </Suspense>
              }
              />
              <Route path="treatment" element={
                <Suspense fallback={<Loading />}>
                  <Treatment />
                </Suspense>
              }
              />
              <Route path="prediction" element={
                <Suspense fallback={<Loading />}>
                  <Prediction />
                </Suspense>
              }
              />
              <Route path="connect/device" element={
                <Suspense fallback={<Loading />}>
                  <DeviceConnectionControll />
                </Suspense>
              }
              />
              <Route path="result" element={
                <Suspense fallback={<Loading />}>
                  <Results />
                </Suspense>
              }
              />
            </Route>
            <Route path='*' element={
              <Suspense fallback={<Loading />}>
                <div>404 Not Found</div>
              </Suspense>
            } />
          </Routes>
        </div>
      </div>
    );
}

export default App;
